<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmPeakPower from 'src/components/EnergyMonitoring/sections/EmPeakPower.svelte';
	import { normalizeEnergyConfig } from '../../../../dash-energy-helpers';
	import type { DashEnergyWidgetConfig } from '../../../../dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig<'dashEnergyPeak'> | undefined;
	export let staticPreview = false;

	$: config = normalizeEnergyConfig('dashEnergyPeak', energyConfig);
</script>

<EmPeakPower variant={config.peakVariant} {staticPreview} />
